import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { loanManagementUrl } from "../../../../config";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../../theme";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import LoanPenaltyApplicationForm from "./forms";
const base_url = loanManagementUrl.uri;

const ignoreFields = [
  "Installments",
  "Installmentamount",
  "Applicationdate",
  "Isloanapproved",
  "Interestamount",
  "Isloancleared",
  "Loandisbursedate",
  "Loanapprovaldate",
  "Arrearsoverduedays",
  "Isinarrears",
  "Rolledover",
  "Expectedcleardate",
  "Interestamount",
  "Arrearsoverduedays",
  "Principlearrears",
  "Interestarrears",
  "Isnonperforming",
  "Rolloverpenalty",
  "Iswrittenoff",
  "Loandeclineid",
  "Isloandeclined",
  "Loandeclinedreason",
  "Writtenoffdate",
  "Rolloverdate",
  "Branchcomments",
  "Iscompanyapproved",
  "Isrescheduled",
  "Accountid",
  "Isrebooked",
  "Channelid",
  "Branchid",
  "Regionid",
  "Companyid",
  "Migratedby",
  "Datecreated",
  "Createdby",
  "Updateddate",
  "Updatedby",
  "Verifiedby",
  "Verifieddate",
  "Name",
  "Loancleareddate",
  "Serviceloans"
];
const columns = [
  { field: "Id", headerName: "CustomerID", flex: 1 },
  { field: "FirstName", headerName: "First Name", flex: 1 },
  { field: "OtherNames", headerName: "Other Names" },
  { field: "MobileNumber", headerName: "Customer Phone" },
  { field: "EmailAddress", headerName: "Email Address" },
  { field: "IdNoOrPassport", headerName: "Id No Or Passport" },
  {
    field: "IsApproved",
    headerName: "Customer Approved",
    flex: 1,
  },
];

const actions = {
  entity: "Register Customer",
  edit: {
    key: "Apply Penalty",
    button_name: "Apply Penalty",
    Show_Button: true,
    permission: "EditPermission",
  },
  dataObject: {
    ignoreFields,
    objectName: "allPenaltyLoanapplication",
    parameters: "",
  },
  showMore: {
    objectname: "dynamicCustomerSearch",
    inputsubobjectname: "customer",
    parameters: "searchTerm",
    search: true,
    min: 3,
    max: 20,
    otherParams: 1,
    isCustomer: true,
  },
};
function ApplyLoanPenalty() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <DynamicTableForJson
        title="Penalty"
        subtitle="View all Loans, Apply Penalty"
        FormComponent={LoanPenaltyApplicationForm}
        // columns={columns}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default ApplyLoanPenalty;
